const handleFooterDropdowns = () => {
	const $footer = $('.footer-main');
	const $nav = $footer.find('.footer__nav');
	const $navTrigger = $nav.find('h5');
	const $navItem = $nav.find('ul');

	$navTrigger.on('click', function(event) {
		event.preventDefault();
		const $this = $(this);

		if($(window).width() > 1023) {
			return
		}

		$this.parent().toggleClass('is-active');

		$this.next()
			.stop()
			.slideToggle()
				.parent()
				.siblings()
					.removeClass('is-active')
						.find($navItem)
						.slideUp();
	});
};

handleFooterDropdowns();
